export class SortDirection {
    public static Ascending = 'Ascending';
    public static Descending = 'Descending';
}